<div [id]="chartId" class="chart-container" #chartContainer>
    <ng-content select="[chart-controls]"></ng-content>
    <div class="chart-header">
        <p class="chart-title">{{chartTitle}}</p>
    </div>
</div>
<div  class="keys-container">
    <ng-container *ngIf="showKey">
        <div *ngFor="let key of keys" class="key-container">
            <div class="key-circle" [style.background-color]="key.color"></div><div>{{key.name}}</div>
        </div>
        <div class="key-container" *ngIf="hasForecast"> 
            <svg width="13.5" height="23">
                <path d="M0,11L13.5,11" stroke="#FCFCFC" stroke-dasharray="2 2"></path>
            </svg>
            Forecast
        </div>
    </ng-container>
</div>
